import { clearLanguageSwitchSplash } from "./languageSwitchSplash";

const LOCK_STYLE_PROPS = [
  "overflow",
  "overflow-x",
  "overflow-y",
  "padding-right",
  "padding-left",
  "padding-inline-end",
  "padding-inline-start",
  "width",
  "position",
  "height",
  "touch-action",
] as const;

/** Strip inline scroll-lock / scrollbar-compensation styles Ant Modal may leave on `body` / `html`. */
export function clearModalBodyLocks(): void {
  for (const prop of LOCK_STYLE_PROPS) {
    document.body.style.removeProperty(prop);
    document.documentElement.style.removeProperty(prop);
  }
  document.body.classList.remove("ant-scrolling-effect");
  document.documentElement.classList.remove("ant-scrolling-effect");
}

/**
 * Run after HyperPay (or similar) sends the browser to `/result` — clears:
 * - Full-screen `#ac-lang-switch-overlay` (needs `html.ac-app-ready` immediately, not after App’s 3s timer)
 * - Stuck modal scroll-lock on `body` / `html`
 */
export function resetDocumentAfterPaymentReturn(): void {
  clearLanguageSwitchSplash();
  clearModalBodyLocks();
  queueMicrotask(clearModalBodyLocks);
  requestAnimationFrame(() => {
    clearModalBodyLocks();
    window.setTimeout(clearModalBodyLocks, 120);
    window.setTimeout(clearModalBodyLocks, 400);
  });
}
